import React from "react";
import styles from "../assets/propertyGuardianSolution.module.css";

const PropertyGuardianSolution = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.titleSection}>
            <h3 className={styles.mainTitle}>
              Our Property Guardian Solutions
            </h3>
          </div>

          <div className={styles.description}>
            <p>
              At Global Guardians, we offer innovative property guardian
              solutions for individuals and organisations seeking reliable and
              cost-effective property management options. Our services are
              tailored to meet the unique needs of property owners, while also
              providing affordable housing solutions for our guardians.
            </p>
          </div>

          <div className={styles.featuresSection}>
            <div className={styles.featuresRow}>
              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Cost-Effective</h4>
                <p className={styles.featureDescription}>
                  Our property guardian solutions offer significant cost savings
                  compared to traditional property management options.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Flexible</h4>
                <p className={styles.featureDescription}>
                  We provide flexible arrangements to suit your specific
                  property needs, whether it's short-term or long-term.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Security</h4>
                <p className={styles.featureDescription}>
                  Our guardianship model ensures that your property remains
                  secure and well-maintained at all times.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Community</h4>
                <p className={styles.featureDescription}>
                  Help us to grow our community of responsible guardians who
                  contribute positively to the neighborhoods they inhabit.
                </p>
              </div>
            </div>
          </div>

          <div className={styles.servicesSection}>
            <div className={styles.titleSection}>
              <h3 className={styles.mainTitle}>Our Services</h3>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Property Guardianship</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Guardians Placement</h4>
                  <p className={styles.serviceDescription}>
                    We carefully match responsible guardians with vacant
                    properties, ensuring a mutually beneficial arrangement.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Property Management</h4>
                  <p className={styles.serviceDescription}>
                    We can handle all aspects of property management, including
                    maintenance, inspections, and guardian communications.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Legal Compliance</h4>
                  <p className={styles.serviceDescription}>
                    Rest assured, we ensure full legal compliance with all
                    regulations governing property guardianship.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>
                Vacant Property Management
              </h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Property Protection</h4>
                  <p className={styles.serviceDescription}>
                    Safeguard your vacant property against vandalism, squatting,
                    and deterioration with our comprehensive management
                    solutions.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Regular Inspections</h4>
                  <p className={styles.serviceDescription}>
                    Our team conducts regular inspections to identify and
                    address any issues promptly, maintaining the integrity of
                    your property.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Emergency Response</h4>
                  <p className={styles.serviceDescription}>
                    We provide 24/7 emergency response services to handle any
                    unforeseen incidents swiftly and effectively.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.contactSection}>
            <h4 className={styles.contactTitle}>Get in Touch</h4>
            <p className={styles.contactDescription}>
              Ready to explore our property guardian solutions? Contact us today
              to discuss your property management needs and learn how Global
              Guardians can help you.
            </p>
            <p className={styles.contactEmail}>
              Contact:{" "}
              <a href="mailto:clientcare@global-guardians.co.uk">
                clientcare@global-guardians.co.uk
              </a>{" "}
              and we will be happy to discuss your requirements.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyGuardianSolution;
